import { AuthState } from "../types/AmplifyAuth";
import { AuthWrapper } from "./AuthWrapper";

/**
 * Returns Amplify Login Flow
 * @returns
 */
export const Login = () => {
    return <AuthWrapper authState={AuthState.LOGIN} />;
};
